(function () {
  'use strict';

  var SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');
  var ANCHOR_NAV_SELECTOR = '.boc-visit-nav, .boc-about-nav, .boc-whats-on-nav, .boc-contact-nav, .boc-booking-nav';
  var SHOW_AFTER_PX = 480;

  function getScrollContainer() {
    if (SQUEEZE_QUERY.matches) {
      return document.querySelector('.page-wrapper') || document.documentElement;
    }
    return document.documentElement;
  }

  function getScrollTop() {
    return getScrollContainer().scrollTop;
  }

  function scrollToTop() {
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    getScrollContainer().scrollTo({ top: 0, behavior: behavior });
  }

  function getHeaderOffset() {
    var styles = getComputedStyle(document.documentElement);
    var height = parseInt(styles.getPropertyValue('--header-height'), 10);
    if (!height || Number.isNaN(height)) {
      height = parseInt(styles.getPropertyValue('--boc-header-height'), 10);
    }
    return Number.isNaN(height) ? 88 : height;
  }

  function bindScroll(handler) {
    window.addEventListener('scroll', handler, { passive: true });
    var container = getScrollContainer();
    if (container && container !== document.documentElement) {
      container.addEventListener('scroll', handler, { passive: true });
    }
  }

  function syncHeaderHeight() {
    var header = document.querySelector('[data-boc-header]');
    if (!header) return;

    var height = Math.round(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--boc-header-height', height + 'px');
    document.body.style.setProperty('--header-height', height + 'px');
  }

  function initBackToTop() {
    var button = document.querySelector('[data-boc-back-to-top]');
    if (!button || button.dataset.bocBackToTopInit === 'true') return;
    button.dataset.bocBackToTopInit = 'true';

    function updateVisibility() {
      var visible = getScrollTop() > SHOW_AFTER_PX;
      button.hidden = !visible;
      button.classList.toggle('is-visible', visible);
    }

    button.addEventListener('click', scrollToTop);
    bindScroll(updateVisibility);
    updateVisibility();
  }

  function initStickyAnchorNav(nav) {
    if (!nav || nav.dataset.bocStickyNavInit === 'true') return;
    if (
      nav.classList.contains('boc-visit-nav--disabled') ||
      nav.classList.contains('boc-about-nav--disabled') ||
      nav.classList.contains('boc-whats-on-nav--disabled') ||
      nav.classList.contains('boc-contact-nav--disabled') ||
      nav.classList.contains('boc-booking-nav--disabled')
    ) {
      return;
    }

    nav.dataset.bocStickyNavInit = 'true';

    function updateStuck() {
      var headerOffset = getHeaderOffset();
      var rect = nav.getBoundingClientRect();
      var stuck = rect.top <= headerOffset + 1 && getScrollTop() > 0;
      nav.classList.toggle('is-stuck', stuck);
    }

    bindScroll(updateStuck);
    window.addEventListener('resize', updateStuck);
    updateStuck();
  }

  function initStickyAnchorNavs() {
    document.querySelectorAll(ANCHOR_NAV_SELECTOR).forEach(initStickyAnchorNav);
  }

  function initBocAddToCartLoading() {
    if (document.documentElement.dataset.bocAddToCartInit === 'true') return;
    document.documentElement.dataset.bocAddToCartInit = 'true';

    var ADD_TO_CART_BUTTON_SELECTOR = '.boc-product-card__add[type="submit"], .product-add[type="submit"]';
    var LOADING_BUTTON_SELECTOR = '.boc-product-card__add.is-loading, .product-add.is-loading';

    function isBocAjaxAddToCartForm(form) {
      if (!form || form.dataset.type !== 'add-to-cart-form') return false;
      if (form.classList.contains('boc-product-card__form')) return true;
      if (form.hasAttribute('data-boc-product-form')) return true;
      if (form.closest('.product-purchase-row, .related-card, .boc-product-card')) return true;
      return false;
    }

    function isBocAjaxAddToCartSource(element) {
      if (!(element instanceof Element)) return false;

      var productForm = element.matches('product-form-component')
        ? element
        : element.closest('product-form-component');

      if (!productForm || productForm.closest('.quick-add-modal, quick-add-dialog')) return false;

      var form = productForm.querySelector('form[data-type="add-to-cart-form"]');
      return Boolean(form && isBocAjaxAddToCartForm(form));
    }

    /** @type {HTMLButtonElement | null} */
    var activeButton = null;
    var cartEventSeen = false;
    /** @type {number | undefined} */
    var loadingTimeoutId;
    /** @type {number | undefined} */
    var drawerPollId;

    function clearBocAddToCartLoading() {
      if (loadingTimeoutId) {
        window.clearTimeout(loadingTimeoutId);
        loadingTimeoutId = undefined;
      }

      if (drawerPollId) {
        window.clearInterval(drawerPollId);
        drawerPollId = undefined;
      }

      if (activeButton) {
        activeButton.classList.remove('is-loading');
        activeButton = null;
      }

      document.querySelectorAll(LOADING_BUTTON_SELECTOR).forEach(function (btn) {
        btn.classList.remove('is-loading');
      });
    }

    function beginLoading(btn) {
      activeButton = btn;
      cartEventSeen = false;
      btn.classList.add('is-loading');

      if (loadingTimeoutId) window.clearTimeout(loadingTimeoutId);
      loadingTimeoutId = window.setTimeout(clearBocAddToCartLoading, 15000);
    }

    function waitForCartDrawerThenClear() {
      var cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && cartDrawer.hasAttribute('open')) {
        clearBocAddToCartLoading();
        return;
      }

      if (drawerPollId) window.clearInterval(drawerPollId);

      var attempts = 0;
      drawerPollId = window.setInterval(function () {
        attempts += 1;
        if ((cartDrawer && cartDrawer.hasAttribute('open')) || attempts >= 120) {
          clearBocAddToCartLoading();
        }
      }, 50);
    }

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var btn = target.closest(ADD_TO_CART_BUTTON_SELECTOR);
        if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

        var form = btn.closest('form[data-type="add-to-cart-form"]');
        if (!form || !isBocAjaxAddToCartForm(form)) return;

        // Never disable the submit button here — that cancels form submission.
        // .is-loading uses pointer-events: none to prevent double-clicks.
        beginLoading(btn);
      },
      true
    );

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!isBocAjaxAddToCartSource(event.target)) return;

      cartEventSeen = true;

      if (!event.promise) return;

      event.promise
        .then(function (result) {
          if (result && result.detail && result.detail.didError) {
            clearBocAddToCartLoading();
            return;
          }

          waitForCartDrawerThenClear();
        })
        .catch(function () {
          clearBocAddToCartLoading();
        });
    });

    document.addEventListener('theme-drawer:open', function (event) {
      var drawer = event.target;
      if (drawer instanceof Element && drawer.id === 'cart-drawer') {
        clearBocAddToCartLoading();
      }
    });

    document.addEventListener('shopify:cart:error', clearBocAddToCartLoading);

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !isBocAjaxAddToCartForm(form)) return;

        var btn = form.querySelector(ADD_TO_CART_BUTTON_SELECTOR);
        if (btn && !btn.classList.contains('is-loading')) {
          activeButton = btn;
          btn.classList.add('is-loading');
          if (loadingTimeoutId) window.clearTimeout(loadingTimeoutId);
          loadingTimeoutId = window.setTimeout(clearBocAddToCartLoading, 15000);
        }

        queueMicrotask(function () {
          queueMicrotask(function () {
            if (activeButton && activeButton.classList.contains('is-loading') && !cartEventSeen) {
              clearBocAddToCartLoading();
            }
          });
        });
      },
      true
    );
  }

  function initAll() {
    syncHeaderHeight();
    initBackToTop();
    initStickyAnchorNavs();
    initBocAddToCartLoading();
  }

  window.BocScroll = {
    getContainer: getScrollContainer,
    getTop: getScrollTop,
    getHeaderOffset: getHeaderOffset,
    bind: bindScroll,
    scrollToTop: scrollToTop,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', syncHeaderHeight);

  document.addEventListener('shopify:section:load', function () {
    syncHeaderHeight();
    initStickyAnchorNavs();
    initBackToTop();
  });
})();
